export function currentDate(date) {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
  
    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
  
    return [year, month, day].join('-');
}

export function currentDateTimeISO(date) {
    const d = new Date(date);
    const tzOffset = d.getTimezoneOffset() * 60000; // Offset en milisegundos
    const localISO = new Date(d - tzOffset).toISOString().slice(0, -1); // Ajuste a la zona local
    return localISO;
}